export const ERROR_TAGS = Object.freeze({
    NOT_FOUND: 'not-found',
    UNCAUGHT_ERROR: 'uncaught-error',
    API_ERROR: 'api-error',
    UNAUTHORIZED: 'unauthorized-error',
    NETWORK_ERROR: 'network-error',
    UPSELL_PAGE_ERROR: 'upsell-page-error',
});
export const ERROR_STATUS_CODES = Object.freeze({
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
});
